import { Navigate, Route, Routes } from "react-router-dom"
import StartupsPage from "../pages/startups/StartupsPage"
import AgenciesPage from "../pages/agencies/AgenciesPage"
import TalentsPage from "../pages/talents/TalentsPage"
import PricingPage from "../pages/pricing/PricingPage"
import { NotFoundPage } from "../components/not-found-page/NotFoundPage"

const Navigation = () => {
	return (
		<Routes>
			<Route path="/" element={<StartupsPage />} />
			<Route path="/talents" element={<TalentsPage />} />
			<Route path="/agencies" element={<AgenciesPage />} />
			<Route path="/service-providers" element={<Navigate to="/agencies" replace />} />
			<Route path="/pricing" element={<PricingPage />} />
			<Route path="/startups/pricing" element={<Navigate to="/pricing" replace />} />
			<Route path="/404" element={<NotFoundPage />} />
			<Route path="*" element={<Navigate to="/404" replace />} />
		</Routes>
	)
}

export default Navigation
